import React, { useState, useRef } from 'react';
import IdleTimer from 'react-idle-timer';
import styled from 'styled-components';
import Timeout from './Timeout';
import { InHomeUtils } from '../../../util/inhomeUtils';
import { Pages } from '../../../constants/actionType';
import Iframe from 'react-iframe';

const OverlayContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.8);
    position: fixed;
    inset: 0px;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
`;

const SessionTimeout = (props) => {
  const { time } = props;
  const [state, setState] = useState({
    showModal: false,
    showTimer: true,
    isIdle: false,
    timeOutSeconds: time,
  });
  const [isUserLogout,setIsUserLogout] = useState(false);
  let page = "";
  if(window.location.host.indexOf("www.verizon.com") !== -1){
      page = "https://secure.verizon.com/signin/user/logout" 

  }else{
      page = "https://securesit1.verizon.com/signin/user/logout";            
  }


  const idleTimer = useRef();
  const onContinueClick = () => {
    setState({ ...state, showModal: false });
    sessionStorage?.setItem('fiosTimeout', "false");
  };

  const onEndSessionClick = () => {
    setIsUserLogout(true);
    setState({ ...state, showModal: false });
    setTimeout(() => {
      if (props.history) {
        try {
          InHomeUtils.exitFiosReferral();  
        } catch(ex) {
          console.log(ex);
        }
      }
      else if (window?.external?.reloadUI) {
        console.log('Called window.external.reloadUI');
        try {
          InHomeUtils.clearMemory();  
        } catch(ex) {
          console.log(ex);
        }  finally {
          localStorage?.clear();
          sessionStorage?.clear();      
          window.external.reloadUI();
        } 
      } else {
        window.location.href = `${window?.location?.protocol}//${window?.location?.host}/inhome/fiosreferral`;
        localStorage?.clear();
        sessionStorage?.clear();
        try {
          InHomeUtils.clearMemory();  
        } catch(ex) {
          console.log(ex);
        }  finally {
          localStorage?.clear();
          sessionStorage?.clear();      
          window.location.reload(true);
        }    
      }         
    },2000)    
  };

  const onActive = () => {
    setState((prevState) => ({ ...prevState, isIdle: false }));
  };
  
  const iframeId = document.getElementById("IframeSmb");
  const iframe = document.querySelector("iframe");
  if (iframeId && iframe && iframe.contentWindow) {
    iframe.contentWindow.addEventListener("fiosReferralIdleTimeout", (e) => {
      console.log('fiosReferralIdleTimeout event triggered')
      sessionStorage?.setItem('fiosReferralFlow', true);
      setState((prevState) => ({ ...prevState, isIdle: true, showModal: true }));
      sessionStorage?.setItem('fiosTimeout', true);
    })
  }

  const onIdle = () => {
    if(!iframeId){
      console.log(idleTimer.current);
      const hostedAttractLoop = sessionStorage.getItem("hostedAttractLoop") === "true";
      if (hostedAttractLoop && idleTimer.current && (sessionStorage.getItem('longDurationAPI') === "on" ||
      (document.getElementsByClassName("page-overlay active") && document.getElementsByClassName("page-overlay active").length && document.getElementsByClassName("page-overlay active").length > 0 &&
      document.getElementsByClassName("page-overlay active")[0].querySelectorAll(".section-overlay") && document.getElementsByClassName("page-overlay active")[0].querySelectorAll(".section-overlay").length &&
      document.getElementsByClassName("page-overlay active")[0].querySelectorAll(".section-overlay").length > 0 &&
      document.getElementsByClassName("page-overlay active")[0].querySelectorAll(".section-overlay")[0].querySelector(".spin-loader")))) {
        idleTimer.current.pause();
        setTimeout(()=> {
          idleTimer.current.resume();
        }, 3000);
        return;
      }
      
      const timeoutFlag = sessionStorage?.getItem('fiosTimeout');
      const flowFlag = sessionStorage?.getItem('fiosReferralFlow')
      const attractLoop = sessionStorage?.getItem("fiosReferralAttractLoop");
      if((timeoutFlag === 'false' || timeoutFlag === null ) && (flowFlag === 'true' && attractLoop === "false")){
        setState((prevState) => ({ ...prevState, isIdle: true, showModal: true }));
        sessionStorage?.setItem('fiosTimeout', true);
      } else {
        setState((prevState) => ({ ...prevState, timeOutSeconds: time }));
      }
    }
  };

  const timeoutModal = state.showModal ? <Timeout  continueClick={onContinueClick} endSessionClick={onEndSessionClick} />: <div></div>;

  return state?.showTimer ?(
    <React.Fragment>
    {sessionStorage.getItem('fiosReferralFlow') === 'true' && <IdleTimer
        element={document}
        onActive={onActive}
        onIdle={onIdle}
        debounce={250}
        timeout={state.timeOutSeconds}
        ref={idleTimer}
      />}
      {sessionStorage.getItem('fiosReferralFlow') === 'true' && isUserLogout && <Iframe url={page} display="none" position="absolute" allowtransparency="true" frameBorder="0" />}
      {timeoutModal}
      </React.Fragment>
  ):<div />;
};

export default SessionTimeout;
